import { types } from 'mobx-state-tree';

import stores from 'bootstrap/store';
import { ALL_TYPES_FILTER } from '../routes/activity/constants';


export const PharmacyTechniciansRouteStore = types.model({
  activeTechnicianId: types.maybeNull(types.string),
  filterValue: types.optional(types.string, ''),
  currentPage: types.optional(types.number, 1),
  http: types.optional(types.model({
    listingTechnicians: types.optional(types.number, 0),
    listingPharmacyTechnicianAppCommands: types.optional(types.number, 0),
  }), {}),

  pharmacyTechnicianLogsFilter: types.optional(types.string, ALL_TYPES_FILTER.KEY)
})
.actions(self => ({
  setValue: (prop, value) => self[prop] = value,
  setInitialState: () => {
    self.activeTechnicianId = null;
    self.filterValue = '';
    self.currentPage = 1;
    self.http = {
      listingTechnicians: 0,
      listingPharmacyTechnicianAppCommands: 0,
    };
  },
  incrementHttp: (http) => ++self.http[http],
  decrementHttp: (http) => --self.http[http]
}))
.views(self => ({
  get activeTechnician() {
    return (
      self.activeTechnicianId &&
      stores.global.pharmacyTechnicians.pharmacyTechnicians.get(self.activeTechnicianId)
    );
  },
  getPharmaciesCountCaption(pharmacyTechnician) {
    const pharmacies = (pharmacyTechnician || {}).pharmacies || [];
    const pharmaciesCount = pharmacies.length;
    return `${pharmaciesCount} ${pharmaciesCount === 1 ? 'pharmacy' : 'pharmacies' }`;
  },
  get activeTechnicianPharmaciesCaption() {
    return self.getPharmaciesCountCaption(self.activeTechnician);
  },
}));

export const pharmacyTechniciansRouteStore = PharmacyTechniciansRouteStore.create({});
